import { createSlice } from "@reduxjs/toolkit";
import { getSingleImageData } from "./single-image-actions";

const singleImageSlice = createSlice({
    name:"singleImage",
    initialState:{
        loading:true,
        imageId: null,
        imageDetails: {},
        error:null
    },
    reducers: {},
    extraReducers:{
        [getSingleImageData.fulfilled]: (state,action) => {
            state.loading = false;
            state.imageId = action.payload.imageId;
            state.imageDetails = action.payload.imageDetails;
        },
        [getSingleImageData.rejected]: (state,action) => {
            state.loading = false;
            state.error = action.payload;
        }
    }
})

export const singleImageActions = singleImageSlice.actions;
export default singleImageSlice;